"use client";
import { Link, Text } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { BaseStatCard } from "../card";
export interface OverviewCardProps extends PropsWithChildren {
  title: string;
  colorScheme?: string;

  callToAction?: string;
  value: string;
}
export function OverviewCard({
  title,
  value,
  children,
  callToAction = "Details",
}: OverviewCardProps) {
  return (
    <Link
      href={`#${title.toLowerCase().replace(/\s/g, "-")}`}
      _hover={{
        textDecoration: "none",
        transform: "scale(1.05)",
      }}
      _focus={{
        boxShadow: "none",
      }}
      cursor="pointer"
      transition="transform 0.2s"
      outline="none"
    >
      <BaseStatCard textAlign="center" py="6" bg="white" color="text">
        <Text fontWeight="bold" fontSize="md">
          {title}
        </Text>
        <Text
          fontSize="2xl"
          fontWeight="bold"
          textAlign="center"
          fontFamily="numerical"
        >
          {value}
        </Text>
        <Text align="center" color="gray.500" fontSize="sm">
          {children}
        </Text>
        <Text
          color="lightBlue.500"
          align="center"
          fontWeight="medium"
          fontSize="sm"
        >
          {callToAction}
        </Text>
      </BaseStatCard>
    </Link>
  );
}
